export interface GeoCodingResult {
  display_name: string;
  lat: string;
  lon: string;
}

export async function searchCities(query: string, lang: string = 'ru', limit: number = 5): Promise<GeoCodingResult[]> {
  if (!query) return [];

  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?city=${encodeURIComponent(
      query,
    )}&format=json&limit=${limit}&accept-language=${lang}`,
  );

  if (!res.ok) {
    throw new Error('Ошибка при запросе к Nominatim API');
  }

  return res.json();
}
